export default {
    sign_up: 'Registrarse',
    how_it_works: 'Cómo funciona',
    earn_points_desc: 'Gana EcoCredits cada vez que compres.',
    earn_points: 'GANAR EcoCredits',
    redeem_points: 'CANJEAR EcoCredits',
    redeem_points_desc: 'Canjear EcoCréditos por descuentos exclusivos y regalos.',
    sign_up_desc: 'Crea una cuenta y consigue 500 EcoCredits.',
    see_t_c: 'Lee los Términos y condiciones',
    join_subTitle: 'Conviértete en miembro ahora y consigue EcoCredits para obtener deducciones en efectivo y recompensas exclusivas.',
    send_your_friend: 'Envía tu tarjeta regalo de {amont} a un amigo.',
    purchase: 'Compra',
    coupon: 'Código de descuento',
    login_capital_letters: 'Iniciar sesión',
    login_capital_letters1: 'Iniciar sesión',
    received: 'Recibido',
    subscribe_capital_letters: 'Suscribirse',
    birthday_placeholder: 'DD / MM / AA',
    shop_capital_letters: 'Comprar',
    shop: 'Comprar',
    ecoflow_benefits: 'Ventajas de los EcoCredits',
    complete_profile: 'Completar perfil',
    referral: 'Invita a tus amigos',
    referral_desc: 'Gana EcoCredits por cada amigo que se registre.',
    referral_btn: 'Unirse ahora',
    warranty: 'Garantía',
    points_activity_a: 'Mi actividad',
    points_tab_name: 'Actividad de EcoCredits',
    rewards_tab_name: 'Actividad de premios',
    coupon_used_desc: 'Usa este código en el momento de realizar el pago para canjear tu tarjeta regalo de {amont}.',
    email_address: 'Dirección de correo electrónico',
    give_away: 'Regalar',
    add_my_birthday: 'Añadir fecha de mi cumpleaños',
    subscribe: 'Suscribirse',
    welcome_top_bar: 'Semana EcoCredits de Agradecimiento x Xmas.\n Adquirir Ahora >>',
    welcome_title: 'Hola {username}',
    welcome_sub_title: 'Te damos la bienvenida al programa de recompensas de EcoCredits.',
    profile: 'Perfil',
    status: 'Estado',
    refund: 'Reembolso',
    points_balance: 'Saldo de EcoCredits',
    points_progress_tips: 'EcoCredits necesarios para llegar a {plus}: {points} EcoCredits',
    available: 'Disponible',
    sign_up_text: '500 EcoCredits por unirte al programa',
    redeemed_succ: '¡Canjeados correctamente!',
    current_tier: 'Nivel actual',
    subscribe_now: 'Suscribirse ahora',
    date: 'Fecha',
    used: 'Usado',
    edeemed_rewards_note: 'Tus recompensas canjeadas aparecerán aquí.',
    warranty_capital_letters: 'Garantía',
    days_rules2: 'Válido desde {data}.',
    redeem_now: 'CANJEAR AHORA',
    product_rules: 'Solo para {product}',
    membership_includes: 'ESTAS SON LAS VENTAJAS DE AFILIARSE AL PROGRAMA',
    browse_ecocredits_rewards: 'Explorar recompensas de EcoCredits',
    discount: 'Descuento',
    view_more: 'Ver más',
    profile_desc1: 'Gana hasta 1000 EcoCredits por completar tu perfil.',
    profile_desc2: 'Consigue hasta 1000 EcoCredits por añadir tus datos.',
    points_capital_letters: 'EcoCredits',
    history_note: 'Tu actividad aparecerá aquí. ¿Aún no ves tu actividad? La actividad se actualizará en 24 horas.',
    lucky_flop_start: 'Únete ahora',
    lucky_flop_congrat: '¡Enhorabuena!',
    lucky_flop_get: 'Reclamar',
    lucky_flop_open: 'ABRIR',
    rules: 'Reglas',
    completed_text: 'Ya has conseguido esta recompensa.',
    redeemed: 'Canjeadas',
    birthday: 'CUMPLEAÑOS',
    summary_text: 'Resumen de tus EcoCredits',
    deducted: 'Deducido',
    site_rules: 'Solo para tienda de España.',
    subscribe_hover: 'Suscríbete y gana 500 EcoCredits.',
    subscribe_text: 'Suscríbete al boletín informativo de EcoFlow.',
    store: 'Comprar Ahora',
    membership: 'Miembro',
    join_now: 'ÚNETE AHORA',
    gift_card: 'Tarjeta regalo',
    rewards_redeemed: 'Mis premios',
    redeedmed_tab_name: 'Canjeado',
    issued_tab_name: 'Emitido',
    expired: 'Caducado',
    login: 'INICIAR SESIÓN',
    earn_points_title: 'Formas de ganar EcoCredits',
    have_points: 'Tienes <code>{points} EcoCredits</code>',
    view_all: 'Ver todo',
    add_your_birthday: 'Añade el día de tu cumpleaños',
    earn_point_rule_shop: 'Consigue 1 EcoCredit por cada euro que gastes.',
    off: 'DÉSACTIVÉ',
    earn_point_by_order: 'Gana cada vez que hagas un pedido.',
    registered: 'Registrado',
    birthday_desc2: 'Gana {points} EcoCredits añadiendo tu fecha de nacimiento.',
    sign_up_desc_h: 'Crea una cuenta y consigue 500 EcoCredits.',
    birthday_desc1: 'Añade el día de tu cumpleaños para obtener EcoCredits.',
    or_text: 'O',
    profile_a: 'Perfil',
    days_rules: ' Válido durante {days} días desde el canje.',
    join_title: 'Únete al programa de recompensas de EcoCredits',
    pending: 'Pendiente',
    coming_soon: 'Próximamente',
    shop_to_earn_points: 'Compra para ganar EcoCredits',
    action: 'Acción',
    rewards_title: 'Premios',
    question_title: '¡Responde a las preguntas',
    type_title: 'Tipo',
    discount_type: 'Descuento',
    already_member: '¿Ya eres miembro?  ',
    already_member1: '¿Ya eres miembro?&nbsp;&nbsp;',
    points_activity: 'ACTIVIDAD DE EcoCredits',
    use_this_code_note: 'Usa este código en el momento de realizar el pago para canjear tu tarjeta regalo de <PI1/>.',
    warranty_desc2: '1000 EcoCredits cuando registres un producto.',
    warranty_desc1: '1000 EcoCredits por registrar tu producto',
    redeem_ecocredits_title: 'Canjear recompensas',
    redeem_ecocredits_title_next: 'Puedes canjear las recompensas y descuentos de los nuevos productos. ¡No te lo pierdas!',
    member_exclusive: 'Precios exclusivos para socios',
    redeem_ecocredits_subtitle_next: 'Iscriviti ora e afferra gli accessori per un fotovoltaico da balcone al 50% in meno degli EcoCredits!',
    redeem_ecocredits_rules_title1: 'Introducción al evento:',
    redeem_ecocredits_rules_title2: 'Mecanismo del evento:',
    redeem_ecocredits_rules_desc1:
        'Únete a los eventos de descuentos de ventanas emergentes de “Canjea recompensas de EcoCredits” del 20 al 23 de octubre de 2023. ¡Las ventanas emergentes aparecerán aleatoriamente durante estas fechas!',
    redeem_ecocredits_rules_desc2:
        '1. Desbloquea sorpresas con antelación: Suscríbete y sé el primero en conocer los horarios de inicio sorpresa de los eventos “Canjea recompensas de EcoCredits”.',
    redeem_ecocredits_rules_desc3:
        '2. Maximiza tus EcoCredits: Durante el evento de ventanas emergentes, aprovecha de un descuento en el canje de puntos de hasta el 50%. ¡Deberás ser rápido! Las cantidades de productos participantes son limitadas. Cada día se destacarán en la promoción cuatro productos únicos, cada uno con un máximo de 100 unidades disponibles.',
    points: 'EcoCredits',
    benefits_link_btn: 'Recomendar ahora',
    network_error: 'Error de red',
    confirm_text: '¿Seguro que quieres canjear tus EcoCredits? Esta acción no se puede anular.',
    manually_deducted: 'Restados manualmente',
    redeeming_points: 'CÓMO CANJEAR LOS EcoCredits',
    earning_points: 'CÓMO OBTENER EcoCredits',
    confirm_btn: 'Confirmar',
    faq_title: 'Preguntas frecuentes',
    no_enough_points: 'Error al canjear los EcoCredits. No tienes suficientes EcoCredits',
    no_history_note: '¿Todavía no ves tus EcoCredits? Tu actividad se actualizará en 24 horas.',
    no_coupon_note: 'Todavía no se ha canjeado ninguna recompensa.',
    minimum_price: 'Monto mínimo de compra ({price}).',
    minimum_num: 'Cantidad mínima de artículos ({num} piezas).',
    stay_too_long: 'Tu sesión ha expirado. Por favor, actualiza la página e inténtalo otra vez.',
    order_rule: 'Solo un código promocional por pedido.',
    purchas_rule: 'Al comprar un artículo por un precio inferior al del cupón, se perderá la diferencia.',
    profile_birthday: 'Perfil - cumpleaños',
    profile_address: 'Perfil - dirección',
    profile_username: 'Perfil - nombre de usuario',
    profile_picture: 'Perfil - foto',
    profile_contact: 'Perfil - información de contacto',
    membership_faq_title: 'MEMBRESÍA',
    learn_more: 'Más información',
    profile_detail:
        'Completa tu perfil para obtener hasta 1000 EcoCredits, incluyendo la foto de perfil (200), el nombre de usuario (100), la información de contacto (300), la dirección (200) y el cumpleaños (200).',
    exceeded_counts: 'No se puede canjear. Has superado el límite de canje.',
    grab_title: 'Consigue un bonus EcoCredits',
    grab_sub_title: 'Ofertas exclusivas por tiempo limitado para miembros de EcoCredit. ¡Haga clic para reclamar ahora!',
    grab_btn_text: 'Conseguir mi bonus',
    grab_success_title: 'Felicitaciones',
    grab_success_text1: '¡Bonus reclamado con éxito!\n Pega el código en la caja para obtener tu descuento.',
    grab_success_text2: 'Consulta tus bonus en <code>Mis Recompensas</code>.',
    'no-grab-content-note': '¡Próximamente más ofertas!',
    copy_desc_2: 'Has copiado el código.',
    city_validatino_error: 'Ciudad no válida',
    product_text: 'Producto',
    shipping_address_text: 'Dirección de envío',
    saved_address_text: 'Direcciones registradas',
    use_new_address: 'Utiliza una nueva dirección',
    spend_now: 'Gastar Ahora',
    stock_left: '{stock} Restantes',
    no_stock_tip: 'Próximamente... ¡Esté atento!',
    order_text: 'Pedido',
    campaign_time_limit_text: 'Periodo de canje válido: {startTime} - {endTime}.',
    event_action_text: 'Actividad',
    warranty_minus_action_text: 'Garantía eliminada',
    question_correctly: 'Responde la pregunta correctamente',
    follow_instagram_text: 'Síguenos en Instagram',
    follow_facebook_text: 'Síguenos en Facebook',
    join_facebook_text: 'Únete al grupo de FB',
    referral_correctly: 'Programa de recomendación',
    confirm_btn_text: 'Cerrar',
    lucky_turntable_title: 'Lucky Spin',
    lucky_turntable_title2: 'Sorteo de premios',
    join_lucky_with_points: 'Necesitas {points} EcoCredits para girar una vez Lucky Spin.',
    join_lucky_with_points2: 'Jugar una ronda te cuesta {points} EcoCredits.',
    join_lucky_desc: '¡Gira la ruleta y consigue un gran premio!',
    remaining_number: '<code></code> gira a la izquierda',
    remaining_number2: 'Te quedan <code></code> intentos',
    learn_lucky_rule: 'Obtén más información sobre las reglas',
    prize_coupon_title: '¡Enhorabuena!',
    prize_coupon_sub_title: '¡Premio reclamado correctamente! Usa el código cuando pagues para ahorrar.',
    prize_coupon_action: 'Consulta tus premios en <code>Mis recompensas</code>.',
    prize_coupon_button: 'Comprar ahora',
    prize_points_title: '¡Enhorabuena!',
    prize_points_desc: 'Consulta los EcoCredits recién añadidos en <code>Mi actividad</code>.',
    limit_times_in_day: 'Puedes girar las ruletas <count></count> veces en <day></day> días',
    limit_times_in_day2: 'Puedes dar la vuelta a las tarjetas <count></count> veces en <day></day> días',
    limit_times_in_active: 'Durante el evento, puedes girar las ruletas hasta <count></count> veces.',
    limit_times_in_active2: 'Durante el evento, puedes dar la vuelta a las cartas hasta <count></count> veces.',
    without_limit_times: 'Puedes girar las ruletas <count></count> veces en cualquier momento.',
    without_limit_times2: 'Puedes dar la vuelta a las cartas <count></count> veces en cualquier momento.',
    active_is_unstart: 'El evento empezará pronto.',
    active_is_ended: 'Este evento ha finalizado.',
    over_max_count: 'Has superado el número de veces que puedes girar la ruleta.',
    notice_title: 'Aviso',
    members_nav: 'Precios para miembros',
    referral_nav: 'Invita a un amigo',
    points_cash: 'Canje de Puntos',
    Pending1: 'Pendiente',
    rollback: 'Devuelto',
    product_hot_title: 'Lo más destacado',
    product_hot_desc: '¡No te lo pierdas! ¡Compra ahora y obtén regalos exclusivos y descuentos imbatibles!',
    product_refurbished_title: 'Productos reacondicionados: ¡mejores ofertas durante un tiempo limitado!',
    product_refurbished_desc: '17/10/2024 09:00 (CEST) - 28/10/2024 08:59 (CEST)',
    level_change_log: 'Actividad de nivel',
    deadline: 'Válido hasta',
    history_refresh_member: 'Nivel actual: Miembro',
    history_refresh_plus_member: 'Nivel actual: Miembro PLUS',
    register: 'Registrarse como miembro',
    upgrade: 'Actualizar a miembro PLUS',
    demotion: 'Volver al nivel Miembro',
    relegation: 'Seguir siendo miembro PLUS',
    wattayear_2024: 'Compartir#WattAYear',
    clock_in: '',
    copy_success1: 'Has copiado el código; ve a la tienda para usarlo.',
};
